import React from 'react';
import { Button, Modal, Icon } from 'antd';

const ModalCreateOrder = ({
  visibleModal,
  closeModal,
  // openSaveTemplate,
  formSubmit,
}) => {
  return (
    <Modal
      visible={visibleModal}
      title={
        <div>
          <Icon style={{ color: '#9b9b9b' }} type="question-circle" />
          Внимание
        </div>
      }
      onCancel={closeModal}
      className="modal-template-order save"
      centered={true}
      footer={[
        <Button key="cancel" onClick={closeModal}>
          Отмена
        </Button>,
        // <Button
        //   key="template"
        //   type="primary"
        //   className="save-template"
        //   onClick={openSaveTemplate}
        // >
        //   Сохранить как шаблон
        // </Button>,
        <Button key="submit" type="primary" onClick={formSubmit}>
          Оформить заказ
        </Button>,
      ]}
    >
      <p>Вы уверены, что хотите оформить заказ с выбранными параметрами?</p>
    </Modal>
  );
};

export default ModalCreateOrder;
